module.exports = __webpack_public_path__ + "img/back-bg.ea92a46e.png";